module.exports = __webpack_public_path__ + "img/luck.966589c9.jpg";